const translations = {
    estimatedTotal: 'ESTIMATED TOTAL'
};

export default translations;
